import { createContext, useEffect, useReducer, useCallback } from "react";
import { LoadingProgress } from "components/loader";
import { AuthService } from "api";
const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT":
      {
        return {
          isInitialized: true,
          user: action.payload.user,
          isAuthenticated: action.payload.isAuthenticated
        };
      }
    case "LOGIN":
      {
        return {
          ...state,
          isAuthenticated: true,
          user: action.payload.user
        };
      }
    case "LOGOUT":
      {
        return {
          ...state,
          user: null,
          isAuthenticated: false
        };
      }
    case "REGISTER":
      {
        return {
          ...state,
          isAuthenticated: true,
          user: action.payload.user
        };
      }
    default:
      {
        return state;
      }
  }
};
export const AuthContext = createContext({});
export const AuthProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  // USER LOGIN HANDLER
  const login = useCallback(async (phone, password) => {
    const response = await AuthService.login(phone, password);
    dispatch({
      type: "LOGIN",
      payload: {
        user: response.user
      }
    });
  }, []);

  // USER REGISTER HANDLER
  const register = useCallback(async (phone, username, password) => {
    const response = await AuthService.signup(phone, username, password);
    dispatch({
      type: "REGISTER",
      payload: {
        user: response.user
      }
    });
  }, []);

  // USER LOGOUT HANDLER
  const logout = async () => {
    await AuthService.logout();
    dispatch({
      type: "LOGOUT"
    });
  };
  useEffect(() => {
    (async () => {
      try {
        if (AuthService.isAuthenticated()) {
          const user = await AuthService.getCurrentUser();
          dispatch({
            type: "INIT",
            payload: {
              user,
              isAuthenticated: true
            }
          });
        } else {
          dispatch({
            type: "INIT",
            payload: {
              user: null,
              isAuthenticated: false
            }
          });
        }
      } catch (err) {
        dispatch({
          type: "INIT",
          payload: {
            user: null,
            isAuthenticated: false
          }
        });
      }
    })();
  }, []);

  // show loading until not initialized
  if (!state.isInitialized) return <LoadingProgress />;
  return <AuthContext.Provider value={{
    ...state,
    method: "JWT",
    login,
    register,
    logout
  }}>
      {children}
    </AuthContext.Provider>;
};